import { useTours } from 'features/Responder/features/Tours';
import { useZones } from 'features/Responder/features/Zones';
import React, { useEffect } from 'react';
import { Form } from 'react-bootstrap';
import { useResponderMap } from 'features/Responder/features/ResponderMap/contexts/ResponderMapContext';

export default function ZoneToolsPanel() {
  const { mapTool, setMapTool } = useTours();
  const { zonesWithMeta } = useZones();
  const { showZoneTools, setShowZoneTools } = useResponderMap();

  const pendingParentId = mapTool?.mode === 'zone' ? mapTool?.parentId : null;
  const pendingParentZone =
    pendingParentId != null
      ? zonesWithMeta.find((zone) => `${zone?.id}` === `${pendingParentId}`) || null
      : null;
  const activeShape = mapTool?.mode === 'zone' ? mapTool?.shape : null;
  const awaitingShape =
    mapTool?.mode === 'zone' &&
    (!!mapTool?.awaitingShape || (!!pendingParentZone && !mapTool?.shape));
  const shapeButtonClass = (shape) =>
    `trip-tool responder-interactive-action ${activeShape === shape ? 'is-selected' : ''}`;

  const launchPlacement = (shape) => {
    setMapTool((prev) => {
      const prevZoneTool = prev?.mode === 'zone' ? prev : {};
      const hasParent = prevZoneTool?.parentId != null;
      if (!hasParent) {
        return { mode: 'zone', shape };
      }
      return {
        ...prevZoneTool,
        mode: 'zone',
        shape,
        awaitingShape: false,
      };
    });
    setShowZoneTools(true);
  };

  // Listen for external toggle (from right-click menu)
  useEffect(() => {
    const handler = () => {
      setShowZoneTools((prev) => !prev);
    };
    window.addEventListener('responder-toggle-tools', handler);
    return () => window.removeEventListener('responder-toggle-tools', handler);
  }, [setShowZoneTools]);

  if (!showZoneTools) return null;

  return (
    <div
      className={`trip-tools-panel ${awaitingShape ? 'zone-tools-guided' : ''}`}
      style={{
        zIndex: 650,
        minWidth: 260,
        maxWidth: 260,
        width: 260,
        position: 'static',
        marginBottom: 0,
      }}
    >
      <div className="trip-tools-header d-flex justify-content-between align-items-center">
        <span>Zone Tools</span>
        <Form.Check
          type="switch"
          id="toggle-zone-tools"
          label=""
          checked={showZoneTools}
          onChange={(e) => {
            const next = e.target.checked;
            setShowZoneTools(next);
          }}
          title="Always Show Tools"
        />
      </div>

      <div className="trip-tools-section">
        <div className="trip-tools-label">Add zone</div>
        {awaitingShape && (
          <div className="trip-tool-hint mb-2">
            Creating child zone for{' '}
            <strong>{mapTool?.parentName || pendingParentZone?.name || 'selected parent'}</strong>.
            Pick a shape to continue, or press <kbd>Esc</kbd> to cancel.
          </div>
        )}
        <div className="d-flex flex-column gap-1">
          <button className={shapeButtonClass('square')} onClick={() => launchPlacement('square')}>
            Square
          </button>
          <button className={shapeButtonClass('circle')} onClick={() => launchPlacement('circle')}>
            Circle
          </button>
          <button
            className={shapeButtonClass('triangle')}
            onClick={() => launchPlacement('triangle')}
          >
            Triangle
          </button>
          <button
            className={shapeButtonClass('polygon')}
            onClick={() => launchPlacement('polygon')}
          >
            Polygon
          </button>
        </div>
      </div>
      <div className="trip-tool-hint mt-2">
        Use the Zone Editor to name, color, lock, or delete selected zones.
      </div>
    </div>
  );
}
